// extracted by mini-css-extract-plugin
module.exports = {"button":"_0FK-"};